/*
 * Seletor de kit da página de produto (snippets/product-kit-builder.liquid).
 * Mantém o kit escolhido e as opções de cada peça, e adiciona todas as peças
 * ao carrinho numa única requisição (mesmo fluxo de product-bundle.js).
 */
if (!window.Eurus.loadedScript.has('kit-builder.js')) {
  window.Eurus.loadedScript.add('kit-builder.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      // Instâncias por id de seção, lidas pelo botão de compra (product-kit-buy-button.liquid)
      if (!Alpine.store('xKitBuilders')) Alpine.store('xKitBuilders', {});

      Alpine.data('xKitBuilder', (el) => ({
        config: {},
        kits: [],
        options: [],
        variants: [],
        kitIndex: 0,
        pieces: [],
        activePiece: 0,
        touchX: null,
        loading: false,
        errorMessage: '',
        soldOut: false,

        init() {
          this.config = JSON.parse(el.querySelector('[data-kit-config]').textContent);
          this.kits = this.config.kits;
          this.options = this.config.options;
          this.variants = this.config.variants;
          this.soldOut = !this.variants.some((variant) => variant.available);

          const defaultKit = this.kits.findIndex((kit) => kit.index === this.config.defaultKit);
          this.kitIndex = defaultKit > -1 ? defaultKit : 0;
          this.resizePieces();
          this.$nextTick(() => this.updateGallery());
          Alpine.store('xKitBuilders')[this.config.sectionId] = this;

          // O form criado pelo kit nunca deve ser enviado de forma nativa (sairia da página)
          const form = document.getElementById(this.config.formId);
          if (form && form.querySelector('[data-kit-easify-proxy]')) {
            form.addEventListener('submit', (event) => event.preventDefault());
            // Sem esta flag o Easify recarrega a página depois de adicionar (ele não reconhece
            // o tema Eurus); na página de kit quem atualiza a gaveta do carrinho é o kit.
            window.easifyAddToCartEvent = true;
          }
        },

        // Valores iniciais de uma peça: cor da variante atual e opções com valor único.
        defaultPiece() {
          return this.options.map((option) => {
            if (option.values.length === 1) return option.values[0].value;
            if (option.isColor) return option.selected;
            return null;
          });
        },

        resizePieces() {
          const quantity = this.kits[this.kitIndex] ? this.kits[this.kitIndex].quantity : 1;
          const pieces = this.pieces.slice(0, quantity);
          while (pieces.length < quantity) pieces.push(this.defaultPiece());
          this.pieces = pieces;
          if (this.activePiece > pieces.length - 1) this.activePiece = pieces.length - 1;
        },

        selectKit(index) {
          this.kitIndex = index;
          this.errorMessage = '';
          this.resizePieces();
          this.updateGallery();
        },

        goToPiece(index) {
          if (index < 0 || index > this.pieces.length - 1) return;
          this.activePiece = index;
          this.updateGallery();
        },

        touchStart(event) {
          this.touchX = event.changedTouches[0].clientX;
        },

        touchEnd(event) {
          if (this.touchX === null) return;
          const delta = event.changedTouches[0].clientX - this.touchX;
          this.touchX = null;
          if (Math.abs(delta) < 50) return;
          this.goToPiece(this.activePiece + (delta < 0 ? 1 : -1));
        },

        isPieceComplete(pieceIndex) {
          const variant = this.pieceVariant(pieceIndex);
          return !!(variant && variant.available);
        },

        selectValue(pieceIndex, optionIndex, value) {
          const piece = this.pieces[pieceIndex].slice();
          piece[optionIndex] = value;
          // Limpa as opções seguintes que deixaram de existir com a nova escolha
          for (let o = optionIndex + 1; o < piece.length; o++) {
            if (piece[o] !== null && !this.isValueAvailable(pieceIndex, o, piece[o], piece)) {
              piece[o] = this.options[o].values.length === 1 ? piece[o] : null;
            }
          }
          this.pieces.splice(pieceIndex, 1, piece);
          this.errorMessage = '';
          if (pieceIndex === this.activePiece) this.updateGallery();
        },

        // Mostra na galeria do produto as fotos da peça ativa, reproduzindo
        // updateMultiMediaWithVariant de variant-select.js (fotos com #Cor no alt).
        // mediaKey = "opção-valor" com handle do Liquid, igual ao data-media-type da galeria.
        updateGallery() {
          const sectionId = this.config.sectionId;
          const gallery = document.getElementById('product-media-' + sectionId);
          if (!gallery || !gallery.dataset.mediaWithVariantSelected) return;

          const piece = this.pieces[this.activePiece];
          if (!piece) return;
          const scope = (selector) => document.querySelectorAll(`#ProductModal-${sectionId} ${selector}, #shopify-section-${sectionId} ${selector}`);
          const allMedias = scope('[data-media-option]');
          let newMedias = [];

          const tagged = scope('[data-media-type]:not([data-media-type=""])');
          if (tagged.length) {
            const connects = [];
            this.options.forEach((option, o) => {
              const value = option.values.find((item) => item.value === piece[o]);
              if (value) connects.push(value.mediaKey);
            });
            const matched = Array.from(tagged).filter((media) => {
              const values = media.getAttribute('data-media-type').split('_');
              return values.every((value) => connects.includes(value));
            });
            if (matched.length) newMedias = matched.concat(Array.from(scope('[data-media-type=""]')));
          } else {
            const variant = this.pieceVariant(this.activePiece) || this.variants.find((v) => v.mediaId && v.options.every((value, o) => piece[o] === null || piece[o] === value));
            if (variant && variant.mediaId) {
              newMedias = Array.from(scope(`[data-media-option="${sectionId}-${variant.mediaId}"]`)).concat(Array.from(scope('[data-media-option=""]')));
            }
          }
          if (!newMedias.length) newMedias = Array.from(allMedias);

          allMedias.forEach((media) => media.classList.remove('media_active', 'splide__slide', 'x-thumbnail'));
          newMedias.slice().reverse().forEach((media) => {
            media.classList.add('media_active');
            if (media.classList.contains('media-thumbnail')) media.classList.add('x-thumbnail');
            if (media.classList.contains('media-slide')) media.classList.add('splide__slide');
            if (media.parentElement && media.parentElement.firstChild !== media) media.parentElement.prepend(media);
          });

          const splideEl = document.getElementById('x-product-' + sectionId);
          if (splideEl && splideEl.splide) {
            splideEl.splide.refresh();
            splideEl.splide.go(0);
          }
          const zoomEl = document.getElementById('media-gallery-' + sectionId);
          if (zoomEl && zoomEl.splide) zoomEl.splide.refresh();
          document.dispatchEvent(new CustomEvent(`eurus:media-gallery-ready:${sectionId}`));
        },

        // Um valor está disponível se existir variante em estoque com ele e
        // com as opções anteriores já escolhidas na peça.
        isValueAvailable(pieceIndex, optionIndex, value, piece = this.pieces[pieceIndex]) {
          return this.variants.some((variant) => {
            if (!variant.available || variant.options[optionIndex] !== value) return false;
            for (let o = 0; o < optionIndex; o++) {
              if (piece[o] !== null && variant.options[o] !== piece[o]) return false;
            }
            return true;
          });
        },

        pieceVariant(pieceIndex) {
          const piece = this.pieces[pieceIndex];
          if (!piece || piece.some((value) => value === null)) return null;
          return this.variants.find((variant) => variant.options.every((value, o) => value === piece[o])) || null;
        },

        // Imagem da peça: variante exata ou a primeira variante com a mesma cor.
        pieceImage(pieceIndex) {
          const variant = this.pieceVariant(pieceIndex);
          if (variant && variant.image) return variant.image;
          const colorIndex = this.options.findIndex((option) => option.isColor);
          const piece = this.pieces[pieceIndex];
          if (colorIndex > -1 && piece && piece[colorIndex]) {
            const sameColor = this.variants.find((v) => v.options[colorIndex] === piece[colorIndex] && v.image);
            if (sameColor) return sameColor.image;
          }
          return this.config.fallbackImage;
        },

        pieceTitle(pieceIndex) {
          return (this.pieces[pieceIndex] || []).filter((value) => value !== null).join(' / ');
        },

        inputId(pieceIndex, optionIndex, valueIndex) {
          return `kit-${this.config.sectionId}-${pieceIndex}-${optionIndex}-${valueIndex}`;
        },

        isComplete() {
          return this.pieces.every((_, p) => this.isPieceComplete(p));
        },

        missingMessage() {
          for (let p = 0; p < this.pieces.length; p++) {
            const missing = this.options.find((option, o) => this.pieces[p][o] === null);
            if (missing) {
              const name = missing.name.toLowerCase();
              return this.pieces.length > 1 ? `Peça ${p + 1}: selecione ${name}` : `Selecione ${name}`;
            }
            const variant = this.pieceVariant(p);
            if (!variant || !variant.available) {
              return this.pieces.length > 1 ? `A combinação da peça ${p + 1} está indisponível` : 'Combinação indisponível';
            }
          }
          return '';
        },

        // Preço de referência por peça: variante escolhida ou a variante atual da página.
        basePrice() {
          const current = this.variants.find((variant) => variant.options.every((value, o) => value === this.options[o].selected));
          return (current || this.variants[0]).price;
        },

        kitCompareTotal(kitIndex) {
          const kit = this.kits[kitIndex];
          if (!kit) return 0;
          if (kitIndex === this.kitIndex) {
            return this.pieces.reduce((total, _, p) => {
              const variant = this.pieceVariant(p);
              return total + (variant ? variant.price : this.basePrice());
            }, 0);
          }
          return this.basePrice() * kit.quantity;
        },

        kitTotal(kitIndex) {
          const kit = this.kits[kitIndex];
          if (!kit) return 0;
          const compare = this.kitCompareTotal(kitIndex);
          // Desconto fixo (R$ por peça) ou percentual, conforme a oferta do BOGOS
          if (this.config.discountType === 'fixed') return Math.max(0, compare - kit.discountAmount * kit.quantity);
          return Math.round(compare * (1 - kit.discount / 100));
        },

        kitSavings(kitIndex) {
          return this.kitCompareTotal(kitIndex) - this.kitTotal(kitIndex);
        },

        money(cents) {
          return Alpine.store('xHelper').formatMoney(cents, this.config.moneyFormat);
        },

        // Propriedades preenchidas no form do produto (ex.: Easify), aplicadas a todas as peças.
        formProperties() {
          const form = document.getElementById(this.config.formId);
          const properties = {};
          if (!form) return properties;
          new FormData(form).forEach((value, key) => {
            const match = key.match(/^properties\[(.+)\]$/);
            if (!match) return;
            if (value instanceof File) {
              if (value.name) console.warn('kit-builder: upload de arquivo não suportado em kit', key);
              return;
            }
            if (value !== '') properties[match[1]] = value;
          });
          return properties;
        },

        // withProperties = false no fluxo do Easify, que monta as propriedades sozinho
        buildItems(withProperties = true) {
          const kit = this.kits[this.kitIndex];
          const properties = withProperties ? Object.assign({}, this.formProperties()) : {};
          if (kit.quantity > 1) properties._kit = kit.label;

          const grouped = {};
          this.pieces.forEach((_, p) => {
            const variant = this.pieceVariant(p);
            if (grouped[variant.id]) {
              grouped[variant.id].quantity += 1;
            } else {
              grouped[variant.id] = { id: variant.id, quantity: 1, properties: Object.assign({}, properties) };
            }
          });
          return Object.values(grouped);
        },

        // Quantidade de uma variante no carrinho (soma todas as linhas dela)
        async cartQuantity(variantId) {
          const cart = await fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } }).then((res) => res.json());
          return cart.items.filter((line) => line.variant_id == variantId).reduce((total, line) => total + line.quantity, 0);
        },

        // POST em cart/add.js; lança erro com a mensagem da Shopify quando falha
        async postItems(items, withSections = false) {
          const body = { items };
          if (withSections) body.sections = Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id);
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
          }).then((res) => res.json());
          if (response.status) throw new Error(response.description || response.message || window.Eurus.cart_error);
          return response;
        },

        // Envia o form do produto como o botão do tema faz (product-cart.js): FormData completo,
        // incluindo os campos que o Easify grava no clique (_tpo_price, _tpo_custom_options).
        async postForm(form) {
          const formData = new FormData();
          new FormData(form).forEach((value, key) => {
            if (value !== '' && !(value instanceof File && !value.name)) formData.append(key, value);
          });
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
            body: formData
          }).then((res) => res.json());
          if (response.status) throw new Error(response.description || response.message || window.Eurus.cart_error);
          return response;
        },

        // Com o Easify ativo, cada variante do kit passa pelo fluxo do Easify (botão oculto do
        // form): ele valida as opções e grava o preço delas no form (modo "expand") ou adiciona
        // ele mesmo a peça com os produtos add-on. O carrinho é conferido antes/depois; o que
        // o Easify não adicionou é enviado aqui com o form completo, como o tema faria.
        // Depois de adicionar: "Comprar agora" vai ao checkout; senão abre a gaveta do carrinho
        goToCheckout() {
          window.location.href = window.Shopify.routes.root + 'checkout';
        },

        async addToCartWithEasify(form, easifyButton, checkout = false) {
          const idInput = form.querySelector('input[name="id"]');
          const quantityInput = form.querySelector('input[name="quantity"]');
          const items = this.buildItems(false);

          this.loading = checkout ? 'checkout' : 'cart';
          this.errorMessage = '';
          await Alpine.store('xCartHelper').waitForCartUpdate();
          window.updatingCart = true;

          let added = 0;
          try {
            for (const item of items) {
              const before = await this.cartQuantity(item.id);
              idInput.value = item.id;
              easifyButton.dataset.variantId = item.id;
              if (quantityInput) quantityInput.value = item.quantity;

              const done = new Promise((resolve) => {
                const timer = setTimeout(() => resolve(false), 8000);
                document.addEventListener('tpo_product_added', () => {
                  clearTimeout(timer);
                  resolve(true);
                }, { once: true });
              });
              easifyButton.click();

              // Opções obrigatórias faltando: o Easify mostra os erros e não envia nada
              if (easifyButton.dataset.tpoValidate === 'false') {
                if (!added) this.errorMessage = 'Preencha as opções de personalização.';
                break;
              }
              await done;
              const missing = item.quantity - ((await this.cartQuantity(item.id)) - before);
              if (missing > 0) {
                idInput.value = item.id;
                if (quantityInput) quantityInput.value = missing;
                await this.postForm(form);
              }
              added++;
            }
          } catch (error) {
            this.errorMessage = error.message || window.Eurus.cart_error;
            console.error('kit-builder:', error);
          } finally {
            if (quantityInput) quantityInput.value = 1;
            window.updatingCart = false;
            this.loading = false;
          }

          if (added) {
            if (added < items.length) {
              this.errorMessage = 'Nem todas as peças foram adicionadas. Confira o carrinho.';
            } else if (checkout) {
              return this.goToCheckout();
            }
            Alpine.store('xMiniCart').reLoad();
            if (!(Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable)) {
              Alpine.store('xMiniCart').openCart();
              document.dispatchEvent(new CustomEvent('eurus:cart:redirect'));
            }
            document.dispatchEvent(new CustomEvent('eurus:product:added', { detail: { product: items } }));
            document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          }
        },

        async addToCart(checkout = false) {
          if (!this.isComplete()) {
            this.errorMessage = this.missingMessage();
            const incomplete = this.pieces.findIndex((_, p) => !this.isPieceComplete(p));
            if (incomplete > -1) this.goToPiece(incomplete);
            return;
          }
          const form = document.getElementById(this.config.formId);
          const easifyButton = form && form.querySelector('[data-kit-easify-proxy].tpo_add-to-cart');
          if (easifyButton) return this.addToCartWithEasify(form, easifyButton, checkout);
          if (form && !form.reportValidity()) return;

          this.loading = checkout ? 'checkout' : 'cart';
          this.errorMessage = '';
          const items = this.buildItems();

          const idInput = form && form.querySelector('input[name="id"]');
          if (idInput) idInput.value = items[0].id;

          await Alpine.store('xCartHelper').waitForCartUpdate();
          window.updatingCart = true;

          try {
            const response = await this.postItems(items, true);
            if (checkout) return this.goToCheckout();
            Alpine.store('xCartHelper').reRenderSections(response.sections);
            document.dispatchEvent(new CustomEvent('eurus:product:added', {
              detail: { product: response.items }
            }));
            if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
              Alpine.store('xCartNoti').setItem(response);
            } else {
              Alpine.store('xMiniCart').openCart();
              document.dispatchEvent(new CustomEvent('eurus:cart:redirect'));
            }
            const bubble = document.getElementById('cart-icon-bubble');
            if (bubble) Alpine.store('xCartHelper').currentItemCount = parseInt(bubble.innerHTML);
            document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          } catch (error) {
            this.errorMessage = error.message || window.Eurus.cart_error;
            document.dispatchEvent(new CustomEvent('eurus:product:add-failed', {
              detail: { errorMessage: error }
            }));
            console.error('kit-builder:', error);
          } finally {
            window.updatingCart = false;
            this.loading = false;
          }
        }
      }));
    });
  });
}
